import React from 'react';

import { Box, Typography } from '@mui/material';

import { scoreColor } from './utils';

interface ScoreDonutProps {
  score: number;
  label: string;
}

export default function ScoreDonut({ score, label }: ScoreDonutProps) {
  const radius = 58;
  const circumference = 2 * Math.PI * radius;
  const filled = (score / 100) * circumference;
  const color = scoreColor(score);

  return (
    <Box sx={{ flexShrink: 0, textAlign: 'center', position: 'relative', width: 140, height: 140 }}>
      <svg width="140" height="140" viewBox="0 0 140 140">
        <circle cx="70" cy="70" r={radius} fill="none" stroke="#e0e0e0" strokeWidth="12" />
        <circle
          cx="70"
          cy="70"
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth="12"
          strokeDasharray={`${filled} ${circumference - filled}`}
          strokeDashoffset={circumference * 0.25}
          strokeLinecap="round"
        />
      </svg>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: 140,
          height: 140,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" color="textSecondary">
          {label}
        </Typography>
        <Typography sx={{ fontSize: 36, fontWeight: 700, color }}>{score}%</Typography>
      </Box>
    </Box>
  );
}
